import React, { useContext, useState } from "react";

import { Grid } from "@material-ui/core";
import {
  InputOptionMaster,
  InputReactDatepicker,
  InputTextMaster,
} from "App/Component/ui";
import { changeHandlerLocalStorageForm, isNull } from "App/utils/helpers";
import { FormContext } from "../../context/FormContext";
import {
  TYPE_INSTANCE3,
  TYPE_INSTANCE4,
  WMS_LGS_PEMBELIAN,
} from "App/constants";
import { useInitialMasterSupplier, useSelectOption } from "App/hooks";
import { ModalListPo } from "..";
import { Perhitungan } from "..";
import { SearchIcon } from "App/Assets";
import { STATUS_OPEN_DRAFT_PEMBELIAN, urlGetGudang } from "../../helpers";
import useSelectOptionCustom from "App/hooks/useSelectOptionCustom";
import { LIST_URL_MASTER } from "utils/masters";

export default function FormPembelian({
  listPembelian,
  setListPembelian,
  setNewDataPembelianList,
  menu,
  changeParentData,
}) {
  const { formData, setFormData } = useContext(FormContext);

  const produsen = useSelectOption(
    false,
    "/wmsMasterAsset/master/list-produsen",
    TYPE_INSTANCE4
  );

  const supplier = useInitialMasterSupplier(
    true,
    "/wmsMasterAsset/master/list-supplier"
  );

  const unit = useSelectOption(
    true,
    "/wmsmaster/unit/read_gudang_farmasi",
    TYPE_INSTANCE4
  );

  const gudangUtama = useSelectOption(true, urlGetGudang, TYPE_INSTANCE4);

  const kasBank = useSelectOptionCustom(
    true,
    LIST_URL_MASTER.kas.list,
    TYPE_INSTANCE3,
    "id",
    "nama",
    "id_coa"
  );

  const [showModalListPo, setShowModalListPo] = useState(false);

  const handleChange = (text) => (e) => {
    changeHandlerLocalStorageForm(
      text,
      e,
      formData,
      setFormData,
      WMS_LGS_PEMBELIAN
    );
  };

  const changeSelectCustomWithLocalStorage = (
    e,
    name_id,
    name_label,
    name_code
  ) => {
    setFormData({
      ...formData,
      [name_id]: e?.value,
      [name_label]: e?.label,
      [name_code]: e?.code,
    });

    localStorage.setItem(
      WMS_LGS_PEMBELIAN,
      JSON.stringify({
        ...formData,
        [name_id]: e?.value,
        [name_label]: e?.label,
        [name_code]: e?.code,
      })
    );
  };

  const changeSelectWithLocalStorage = (e, name_id, name_label) => {
    setFormData({
      ...formData,
      [name_id]: e?.value,
      [name_label]: e?.label,
    });

    localStorage.setItem(
      WMS_LGS_PEMBELIAN,
      JSON.stringify({
        ...formData,
        [name_id]: e?.value,
        [name_label]: e?.label,
      })
    );
  };

  const handleClickSelect = (row) => {
    setFormData({
      ...formData,
      is_po: true,
      po_id: row?.id,

      supplier_id: row?.supplier_id,
      supplier: row?.supiler,

      // gudang_id: row?.gudang_id,
      // gudang: row?.gudang,

      unit_id: row?.unit_id,
      unit: row?.unit,

      produsen_id: row?.produsen_id,
      produsen: row?.produsen,

      tax2:row?.tax,
      tax:row?.tax,
    });
    setShowModalListPo(false);
  };

  return (
    <>
      {showModalListPo && (
        <ModalListPo
          setShowModal={() => setShowModalListPo(false)}
          handleClickSelect={handleClickSelect}
        />
      )}

      <Grid container spacing={3}>
        <Grid item sm={6}>
          <form action="">
            <Grid container spacing={1}>
              <Grid item sm={4}>
                {isNull(formData.id) ? (
                  <InputTextMaster
                    name="id"
                    label="ID Pembelian / ID PO"
                    id="id"
                    value={formData?.is_po ? formData?.po_id : formData.id}
                    placeholder={formData?.po_label}
                    disabled={true}
                    withButton={true}
                  >
                    <button
                      type={"button"}
                      onClick={() => setShowModalListPo(!showModalListPo)}
                      style={{
                        borderRight: "1px solid #EAEAEA",
                        borderTop: "1px solid #EAEAEA",
                        borderBottom: "1px solid #EAEAEA",
                        borderLeft: "0",
                        background: "#fff",
                        padding: "0 0.8rem",
                        cursor: "pointer",
                        borderRadius: "0 6px 6px 0",
                      }}
                    >
                      <SearchIcon width={"16"} height={"16"} fill={"#333"} />
                    </button>
                  </InputTextMaster>
                ) : (
                  <InputTextMaster
                    name="id"
                    label="ID Pembelian / ID PO"
                    id="id"
                    value={formData?.ispo ? formData?.idpo : formData?.id}
                    placeholder={formData?.label_po}
                    disabled={true}
                    withButton={false}
                  />
                )}{" "}
              </Grid>
              <Grid item sm={4}>
                <InputTextMaster
                  name="user"
                  label="USER"
                  id="user"
                  disabled={
                    formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                  readOnly={
                    formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                  value={formData?.user}
                  onChange={handleChange("user")}
                  placeholder="Nama User"
                />
              </Grid>
              <Grid item sm={4}>
                <InputTextMaster
                  name="faktur_no"
                  label="NO FAKTUR"
                  id="faktur_no"
                  disabled={
                    formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                  readOnly={
                    formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                  placeholder="No Faktur"
                  value={formData?.faktur_no}
                  onChange={handleChange("faktur_no")}
                />
              </Grid>
              <Grid item sm={4}>
                <InputOptionMaster
                  name="gudang_id"
                  label="GUDANG UTAMA FIXED ASSET"
                  id="gudang_id"
                  withSearch={true}
                  // disabled={ formData.status === STATUS_OPEN_DRAFT_PEMBELIAN ? false : true }
                  disabled={
                    formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                  data={gudangUtama}
                  value={formData?.gudang_id}
                  labelValue={formData?.gudang}
                  onChange={(e) =>
                    changeSelectWithLocalStorage(e, "gudang_id", "gudang")
                  }
                />
              </Grid>
              <Grid item sm={4}>
                <InputOptionMaster
                  name="unit_id"
                  label="UNIT"
                  id="unit_id"
                  withSearch={true}
                  // disabled={formData.is_po ? true : false}
                  disabled={
                    formData.is_po
                      ? true
                      : formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                  data={unit}
                  value={formData?.unit_id}
                  labelValue={formData?.unit}
                  onChange={(e) =>
                    changeSelectWithLocalStorage(e, "unit_id", "unit")
                  }
                />
              </Grid>
              <Grid item sm={4}>
            <InputOptionMaster
              name="produsen_id"
              label="PRODUSEN"
              id="produsen_id"
              withSearch={true}
              disabled={
                    formData.is_po
                      ? true
                      : formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
              data={produsen}
              value={formData.produsen_id}
              labelValue={formData.produsen}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    produsen_id: null,
                    produsen: "Pilih Produsen",
                  });
                } else {
                  setFormData({
                  ...formData,
                  produsen_id: e?.value,
                  produsen: e?.label,
                })
                }
              }}
            />
          </Grid>
              <Grid item sm={4}>
                <InputOptionMaster
                  name="supplier_id"
                  label="SUPPLIER"
                  id="supplier_id"
                  withSearch={true}
                  disabled={
                    formData.is_po
                      ? true
                      : formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                  data={supplier}
                  value={formData?.supplier_id}
                  labelValue={formData?.supplier}
                  onChange={(e) =>
                    changeSelectWithLocalStorage(e, "supplier_id", "supplier")
                  }
                />
              </Grid>

              <Grid item sm={4}>
                <InputReactDatepicker
                  selected={formData.faktur_tgl}
                  label="TGL FAKTUR"
                  handleChangeToday={(e) =>
                    setFormData({
                      ...formData,
                      faktur_tgl: e,
                    })
                  }
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      faktur_tgl: e,
                    })
                  }
                  disabled={
                    formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                  readOnly={
                    formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                />
              </Grid>
              <Grid item sm={4}>
                <InputReactDatepicker
                  selected={formData.jatuhtempo_tgl}
                  label="TGL JATUH TEMPO"
                  handleChangeToday={(e) =>
                    setFormData({
                      ...formData,
                      jatuhtempo_tgl: e,
                    })
                  }
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      jatuhtempo_tgl: e,
                    })
                  }
                  disabled={
                    formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                  readOnly={
                    formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                />
              </Grid>
              <Grid item sm={4}>
                <InputOptionMaster
                  name="kasbank_id"
                  label="KAS BANK"
                  id="kasbank_id"
                  withSearch={true}
                  disabled={
                    formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                  readOnly={
                    formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                  data={kasBank}
                  value={formData?.kasbank_id}
                  labelValue={formData?.kasbank}
                  onChange={(e) =>
                    changeSelectCustomWithLocalStorage(e, "kasbank_id", "kasbank", "coa_code")
                  }
                />
              </Grid>
              <Grid item sm={4}>
                <InputReactDatepicker
                  selected={formData.kedatangan_tgl}
                  label="TGL KEDATANGAN"
                  handleChangeToday={(e) =>
                    setFormData({
                      ...formData,
                      kedatangan_tgl: e,
                    })
                  }
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      kedatangan_tgl: e,
                    })
                  }
                  disabled={
                    formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                  readOnly={
                    formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                />
              </Grid>
              <Grid item sm={4}>
                <InputReactDatepicker
                  selected={formData.tagih_tgl}
                  label="TGL TAGIH"
                  handleChangeToday={(e) =>
                    setFormData({
                      ...formData,
                      tagih_tgl: e,
                    })
                  }
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      tagih_tgl: e,
                    })
                  }
                  disabled={
                    formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                  readOnly={
                    formData.status === STATUS_OPEN_DRAFT_PEMBELIAN
                      ? false
                      : true
                  }
                />
              </Grid>
            </Grid>
          </form>
        </Grid>

        <Grid item sm={6}>
          <Perhitungan
            listPembelian={listPembelian}
            setListPembelian={setListPembelian}
            setNewDataPembelianList={setNewDataPembelianList}
            menu={menu}
            changeParentData={changeParentData}
          />
        </Grid>
      </Grid>
    </>
  );
}
